<template>
  <div>
    <v-dialog v-model="dialog" max-width="400px">
      <v-card flat>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="blue--text text--darken-2 font-weight-bold">
            <v-icon class="mr-2" color="primary">mdi-file-search-outline</v-icon>결재 결과
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <!-- <v-card-text class="pa-8 pr-4 pl-4 pb-4 mt-2"> -->
        <v-card-text class="pa-4 mt-6">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.cUserNm" readonly dense label="결재자" persistent-placeholder></v-text-field>
            </v-col> 
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.cOKDateTime" readonly dense label="결재 시간" persistent-placeholder></v-text-field>
            </v-col> 
            <v-col cols="12" sm="6">
              <v-text-field v-model="editedItem.cState" readonly dense label="상태" persistent-placeholder></v-text-field>
            </v-col> 
            <!-- 승인이면서 false인 경우는 승인 메세지가 없는 경우(방문예약 신청,사진촬영 허가 신청,업체물품 반입 신청 제외한 나머지 신청 항목들) -->
            <!-- <v-col cols="12" v-if="!((editedItem.cState == '승인' || !bOKComment) || editedItem.cState == '종결')"> -->
            <v-col cols="12" v-if="bOKComment">
              <v-textarea v-model="editedItem.cComment" :label="formatLabel" outlined readonly no-resize persistent-placeholder dense></v-textarea>
            </v-col> 
          </v-row>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-2" text @click="dialog = false">
            <v-icon class="mr-2">mdi-close</v-icon>닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {
  },

  data: () => ({
    dialog : false,
    bOKComment : false,
    editedItem : {
      cUserNm : "",
      cState : "",
      cComment : "",
      cOKDateTime : "",
    },
  }),

  computed: {
    formatLabel() {
      return this.editedItem.cState + " 사유"
    }
  },

  created() {
  },

  mounted() {
  },

  methods : {
    ShowDialog(oItem,cState,OKComment){
      this.dialog = true
      // this.bOKComment = bOKComment

      this.bOKComment = !((cState == '승인' && !OKComment) || cState == '종결')

      this.editedItem = Object.assign({},{
        cState : cState,
        cUserNm : oItem.cUserNm,
        cComment : oItem.cComment,
        cOKDateTime : oItem.cOKDateTime.substring(0,10),
      })
    }
  }
}
</script>